"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tdwReportWithVip = exports.getVipVer5 = exports.getVipLevel = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _arkServiceInterface = require("@tencent/ark-service-interface");
var _report = require("../report");
var _getUserInfo = require("../getUserInfo");
var _const = require("./const");
var getVipVer5 = function getVipVer5(vipLevel) {
  if (vipLevel === undefined) {
    return _const.VipReportType.NO_VIP;
  }
  switch (vipLevel) {
    case _arkServiceInterface.VipLevel.NORMAL:
      return _const.VipReportType.VIP;
    case _arkServiceInterface.VipLevel.SUPER:
      return _const.VipReportType.SVIP;
    case _arkServiceInterface.VipLevel.SUPER_PLUS:
      return _const.VipReportType.SVIP_PLUS;
    default:
      return _const.VipReportType.NO_VIP;
  }
};
exports.getVipVer5 = getVipVer5;
var getVipLevel = function getVipLevel(vip) {
  if (typeof vip === 'string' && vip) {
    try {
      return JSON.parse(vip).vip_level;
    } catch (error) {
      return _arkServiceInterface.VipLevel.NONE;
    }
  }
  return _arkServiceInterface.VipLevel.NONE;
};
exports.getVipLevel = getVipLevel;
var tdwReportWithVip = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(param, immediate) {
    var _yield$getVipInfo, vip, vipLevel, ver5;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _getUserInfo.getVipInfo)();
        case 2:
          _yield$getVipInfo = _context.sent;
          vip = _yield$getVipInfo.vip;
          // 不要直接用后台返回的 vipLevel 字段，不准确
          vipLevel = getVipLevel(vip);
          ver5 = getVipVer5(vipLevel);
          (0, _report.tdwReport)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, param), {}, {
            ver5: ver5
          }), immediate);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function tdwReportWithVip(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
exports.tdwReportWithVip = tdwReportWithVip;